import {
  Backdrop,
  CircularProgress,
  CircularProgressProps,
} from '@mui/material';
import { FC, type PropsWithChildren } from 'react';

type LoadingOverlayProps = PropsWithChildren & {
  open?: boolean;
  circularProgessProps?: CircularProgressProps;
};
export const LoadingOverlay: FC<LoadingOverlayProps> = ({
  open,
  circularProgessProps,
  children,
}) => {
  return (
    <Backdrop
      open={open === undefined ? true : open}
      sx={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CircularProgress size='2em' {...circularProgessProps} />
      {children}
    </Backdrop>
  );
};
